import { getApi } from "../base.api";

export const getAllCompany = async() => {
    const data = await getApi('files/companies');
    return data;
}